import { ActionTypesFactory } from "../../utils";

export const Dashboard = ActionTypesFactory("Dashboard", "Dashboard");
export const ErrorModal = ActionTypesFactory("Global", "ErrorModal");

export const dashboard = (payload) => {
  return {
    type: Dashboard.REQUEST,
    payload,
  };
};

export const errorModalReset = () => {
  return {
    type: ErrorModal.RESET,
  };
};



